import Alpine from "alpinejs"
import { Splide } from "@splidejs/splide"

Alpine.data("proConSlider", () => ({
    splide: null,
    splideOptions: {
        type: "slide",
        drag: true,
        perPage: 1,
        mediaQuery: "min",
        breakpoints: {
            0: {
                padding: { right: "15%" },
            },
            640: {
                padding: { right: "20%" },
            },
        },
        autoWidth: true,
        arrows: false,
        gap: "1rem",
        isNavigation: false,
        pagination: false,
    },
    next: function () {
        this.splide.go("+1")
        this.updateControls()
    },
    prev: function () {
        this.splide.go("-1")
        this.updateControls()
    },
    updateControls() {
        const totalSlides = this.splide.Components.Controller.getEnd() + 1
        const currentSlideIndex = this.splide.index
        const prevButton = this.$refs.prevButton
        const nextButton = this.$refs.nextButton

        // Check if totalSlides is valid before calculating the progress
        if (totalSlides && totalSlides > 0) {
            const progressPercentage = ((currentSlideIndex + 1) / totalSlides) * 100
            this.$refs.progressBar.style.width = `${progressPercentage}%`
        }

        // Disable prev button if we're on the first slide
        if (this.splide.index === 0) {
            prevButton.classList.add("disabled")
        } else {
            prevButton.classList.remove("disabled")
        }

        // Disable next button if we're on the last slide
        if (this.splide.index === this.splide.length - this.splide.options.perPage) {
            nextButton.classList.add("disabled")
        } else {
            nextButton.classList.remove("disabled")
        }
    },
    init() {
        this.splide = new Splide(this.$refs.slider, this.splideOptions).mount()
        // Call updateControls initially to disable buttons if needed
        this.splide.on("mounted move", () => {
            this.updateControls()
        })

        // Apply grab cursor style to the slider element
        this.$refs.slider.style.cursor = "grab"

        // Add event listeners to change cursor on drag
        this.splide.on("drag", () => {
            this.$refs.slider.style.cursor = "grabbing"
        })

        this.splide.on("dragged", () => {
            this.$refs.slider.style.cursor = "grab"
        })

        this.$nextTick(() => {
            // Delay to ensure Splide instance has been mounted and slides are ready
            this.updateControls()
        })
    },
}))
